import React from 'react';
import styled from 'styled-components';

import Text from 'components/common/Text';
import { ScheduleState } from 'types/api';

const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 4px 10px;

  border-radius: 8px;
  background: #f7f7f8;
  white-space: nowrap;
`;

const StatusButton = styled.div<{ background: string }>`
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: ${props => props.background};
`;

interface Props {
  status: ScheduleState;
  isMobile: boolean;
  style?: React.CSSProperties;
}

const ScheduleStatusButton = (props: Props) => {
  const { status, isMobile, style } = props;

  const renderStatusButton = () => {
    switch (status) {
      case ScheduleState.EDITING:
        return (
          <>
            <StatusButton background="#414B56" />
            <Text
              color="#1b1c1e"
              size={isMobile ? '14px' : '16px'}
              weight={isMobile ? 600 : 500}
            >
              등록중
            </Text>
          </>
        );
      case ScheduleState.OPENED:
        return (
          <>
            <StatusButton background="#0071E9" />
            <Text
              color="#1b1c1e"
              size={isMobile ? '14px' : '16px'}
              weight={isMobile ? 600 : 500}
            >
              판매중
            </Text>
          </>
        );
      case ScheduleState.PAUSED:
        return (
          <>
            <StatusButton background="#FF9200" />
            <Text
              color="#1b1c1e"
              size={isMobile ? '14px' : '16px'}
              weight={isMobile ? 600 : 500}
            >
              일시중지
            </Text>
          </>
        );
      case ScheduleState.SOLD_OUT:
        return (
          <>
            <StatusButton background="#C2C4C8" />
            <Text
              color="#1b1c1e"
              size={isMobile ? '14px' : '16px'}
              weight={isMobile ? 600 : 500}
            >
              매진
            </Text>
          </>
        );
      case ScheduleState.CANCELED:
        return (
          <>
            <StatusButton background="#FF4242" />
            <Text
              color="#1b1c1e"
              size={isMobile ? '14px' : '16px'}
              weight={isMobile ? 600 : 500}
            >
              취소
            </Text>
          </>
        );
      default:
        return (
          <>
            <StatusButton background="#414B56" />
            <Text
              color="#1b1c1e"
              size={isMobile ? '14px' : '16px'}
              weight={isMobile ? 600 : 500}
            >
              등록중
            </Text>
          </>
        );
    }
  };

  return <Container style={{ ...style }}>{renderStatusButton()}</Container>;
};

export default ScheduleStatusButton;
